import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const LMSCoursesBasicComponent = ({
    selectLMSCourses, handleInnerFormChange
}: any) => {

    return (
        <AccordionContainer
            child={
                <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                    <InputContainer
                        label="Title"
                        labelField="Title"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(event.target.value, 'Title');
                        }}
                        type="text"
                        value={selectLMSCourses?.Title}
                    />
                    
                        <InputContainer
                            label="Author"
                            name="Author"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(event.target.value, 'Author');
                            }}
                            type="text"
                            value={selectLMSCourses?.Author}
                        />
                   
                    
                        <InputContainer
                            label="published date"
                            name="publishedDate"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(event.target.value, 'publishedDate');
                            }}
                            type="date"
                            value={selectLMSCourses?.publishedDate}
                        />
                    
                    
                        <InputContainer
                            label="short description"
                            name="shortDescription"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(event.target.value, 'shortDescription');
                            }}
                            type="text"
                            value={selectLMSCourses?.shortDescription}
                        />
                    

                    <div className='col-span-full'>
                        <InputContainer
                            label="Description"
                            name="Description"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(event, 'Description');
                            }}
                            type="rte"
                            value={selectLMSCourses?.Description}
                        />
                    </div>
                    
                </div>
            }
            expandedPanel="BasicInfo"
            headerTitle="Basic Info"
        />
    );
};

export default LMSCoursesBasicComponent;
